angular.module('TetherApp').controller('KeywordActivityController', [
    '$controller',
    '$window',
    'keywordService',
    function (
        $controller,
        $window,
        keywordService
    ) {
        let self = this;

        self.participantController = $controller('ParticipantController');

        self.delete = function(keywordId) {
            if($window.confirm(self.deleteConfirmationText)) {
                keywordService.deleteKeyword(keywordId)
                    .then(onKeywordDelete, onError);
            }
        };

        let onKeywordDelete = function (data) {
            $window.location.reload();
        };

        let onError = function(reason) {
            // console.log('Error occurred while deleting keyword');
        };
    }
]);
